[
    {
        "storeNumber": "502",
        "country": "NLD",
        "disableStoreSwitching": true,
        "hideFromOtherStores": true
    },
    {
        "storeNumber": "545",
        "country": "NLD",
        "disableStoreSwitching": true,
        "hideFromOtherStores": true
    },
    {
        "storeNumber": "640",
        "country": "NLD",
        "disableStoreSwitching": true,
        "hideFromOtherStores": false
    },
    {
        "storeNumber": "173",
        "country": "USA",
        "disableStoreSwitching": true,
        "hideFromOtherStores": false
    },
    {
        "storeNumber": "200",
        "country": "USA",
        "disableStoreSwitching": true,
        "hideFromOtherStores": true
    },
    {
        "storeNumber": "201",
        "country": "USA",
        "disableStoreSwitching": true,
        "hideFromOtherStores": true
    }
]